import * as React from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import AvatarView from "../Avatar";
import FormEditUser from "../../FormRegistercommerce/FormEditUser";
import FormOther from "../../FormRegistercommerce/FormOtherConfig";

export default function StartUser({ name, ...pros }) {

  return (
    <Grid container spacing={3}>
      {/* VISTA DE AVATAR */}
      <Grid item xs={12} md={4} lg={3}>
        <Paper
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
            height: 220,
          }}
        >
          <AvatarView />
        </Paper>
      </Grid>
      {/* DATOS DE USUARIO */}
      <Grid item xs={12} md={8} lg={9}>
        <Paper
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <FormEditUser />
        </Paper>
      </Grid>

      {/* CAMBIO DE CLAVE */}
      <Grid item xs={12}>
        <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
          <FormOther />
        </Paper>
      </Grid>
    </Grid>
  );
}
